<p-tabView (onChange)="loadPage($event)"> 
  <p-tabPanel header="Merge Cyclists" leftIcon="pi pi-users" tooltip="Merge Cyclist information">
    <app-merge-cyclist *ngIf="showMerge"></app-merge-cyclist>
  </p-tabPanel>

  <p-tabPanel header="Copy Stores" leftIcon="pi pi-clone" tooltip="Copy the settings of one store to other stores">
    <app-copy-shops *ngIf="showCopy"></app-copy-shops>
  </p-tabPanel>

  <p-tabPanel header="Franchise Link" leftIcon="pi pi-share-alt" tooltip="Link multiple stores to a single store">
    <app-franchise *ngIf="showFranchise"></app-franchise>
  </p-tabPanel>


</p-tabView>
